import React, { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import Draggable from "react-draggable";
import { EllipsisTooltipText } from "../../../common/components/EllipsisTextWithTooltip";

export const AIValuesModal = ({ fieldValue, onCancel, heading, showSaveAction = false, onSaveValue, getSaveDisabledReason, onEditValue }) => {
    const [copySuccess, setCopySuccess] = useState(null);

    const handleCopy = index => {
        setCopySuccess(index);
        setTimeout(() => setCopySuccess(null), 2000);
    };

    const getDisplayValue = value => {
        if (value === null || value === undefined || value === "") return "-";
        if (typeof value === "object") return JSON.stringify(value);
        return value?.toString();
    };

    return (
        <div className="modal analyse_reference_modal ai_multiple_values_modal" style={{ display: "block" }} tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-lg" role="document">
                <Draggable handle=".draggable" cancel=".not-draggable">
                    <div className="modal-content">
                        <div className="modal-header draggable">
                            <h5 className="modal-title">{heading}</h5>
                            <button type="button" className="close" onClick={onCancel}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>

                        <div className="modal-body analyse_reference_body not-draggable">
                            {Array.isArray(fieldValue) && fieldValue.length > 0 ? (
                                <div className="analyse_ai_values_grid">
                                    {fieldValue.map((item, index) => {
                                        const displayVal = getDisplayValue(item);
                                        const isUrl = typeof displayVal === "string" && /^(https?:\/\/[^\s]+)/.test(displayVal);
                                        const saveDisabledReason =
                                            typeof getSaveDisabledReason === "function" ? getSaveDisabledReason(displayVal, index) : "";
                                        const canSaveValue =
                                            showSaveAction &&
                                            typeof onSaveValue === "function" &&
                                            displayVal &&
                                            displayVal !== "-" &&
                                            !saveDisabledReason;

                                        return (
                                            <div className="analyse_ai_value_cell" key={`${displayVal}_${index}`}>
                                                <div className="url-wrp">
                                                    {isUrl ? (
                                                        <a href={displayVal} target="_blank" rel="noopener noreferrer">
                                                            <EllipsisTooltipText text={displayVal ?? ""} />
                                                        </a>
                                                    ) : (
                                                        <EllipsisTooltipText text={displayVal ?? ""} />
                                                    )}
                                                    {!displayVal || displayVal === "-" ? (
                                                        <div className="icon ai-copy cursor-diabled" style={{ cursor: "not-allowed" }}>
                                                            <i
                                                                className="fa fa-copy"
                                                                data-tip="No value to copy"
                                                                data-for="Asset_details"
                                                                data-place="left"
                                                                style={{ color: "#4B90FA" }}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <CopyToClipboard
                                                            text={displayVal?.replace(/\s*\(\s*(?:image|web)(?:\s*\|\s*(?:image|web))?\s*\)/gi, "")}
                                                            onCopy={() => handleCopy(index)}
                                                        >
                                                            <div className="rt-data" style={{ cursor: "pointer" }}>
                                                                {copySuccess === index ? (
                                                                    <i className="fa fa-check" style={{ color: "green" }} />
                                                                ) : (
                                                                    <i className="fa fa-copy" style={{ color: "#4B90FA" }} />
                                                                )}
                                                            </div>
                                                        </CopyToClipboard>
                                                    )}
                                                    {showSaveAction && (
                                                        <div
                                                            className={`rt-data ml-2 ${canSaveValue ? "cursor-hand" : "cursor-diabled"}`}
                                                            style={{ cursor: canSaveValue ? "pointer" : "not-allowed" }}
                                                            data-tip={!displayVal || displayVal === "-" ? "No value" : saveDisabledReason || "Save"}
                                                            data-for="Asset_details"
                                                            data-place="left"
                                                            onClick={() => {
                                                                if (canSaveValue) onSaveValue(displayVal);
                                                            }}
                                                        >
                                                            <img className="original-asset-value-save" src="/img/Green 1.svg" alt="" />
                                                        </div>
                                                    )}
                                                    {showSaveAction && typeof onEditValue === "function" && (
                                                        <i
                                                            className={`fa fa-pencil-alt ml-2 ai-edit-icon ${
                                                                saveDisabledReason ? "cursor-disabled" : "cursor-hand"
                                                            }`}
                                                            style={{ color: "#4B90FA" }}
                                                            data-tip={saveDisabledReason || "Edit"}
                                                            data-for="Asset_details"
                                                            data-place="left"
                                                            onClick={() => {
                                                                if (!saveDisabledReason) onEditValue(displayVal === "-" ? "" : displayVal);
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <p>No data available</p>
                            )}
                        </div>
                    </div>
                </Draggable>
            </div>
        </div>
    );
};
